import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ToggleSwitchButtonComponent } from './components/toggle-switch-button/toggle-switch-button.component';
import { FormsModule } from '@angular/forms';
import { SelectIconsComponent } from './components/select-icons/select-icons.component';
import { SharedDataAccessUserModule } from '@lcms/shared/data-access-user';
import { NgbDropdownModule } from '@ng-bootstrap/ng-bootstrap';

@NgModule({
  declarations: [ToggleSwitchButtonComponent, SelectIconsComponent],
  imports: [CommonModule, FormsModule, SharedDataAccessUserModule, NgbDropdownModule],
  exports: [ToggleSwitchButtonComponent, SelectIconsComponent],
})
export class SharedUiModule {}
